import React from 'react'
import { Form } from 'semantic-ui-react'
import { courseTypesFormated } from '../../../common/config'

const CourseTypeFilter = ({ value, onChange, ...remainingProps }) => {
  const courseTypeOptions = Object.keys(courseTypesFormated).reduce((types, key) => {
    types.push({ value: key, text: courseTypesFormated[key].name })
    return types
  }, [])
  if (!remainingProps.multiple) courseTypeOptions.unshift({ value: '', text: 'Vše' })
  let realValue = value
  if (!realValue && remainingProps.multiple) realValue = []
  return (
    <Form.Select
      options={courseTypeOptions}
      value={realValue}
      onChange={(e, value) => onChange(value)}
      {...remainingProps}
    />
  )
}

CourseTypeFilter.defaultProps = {
  multiple: false,
  value: '',
}

CourseTypeFilter.propTypes = {
  multiple: React.PropTypes.bool,
  value: React.PropTypes.any,
  onChange: React.PropTypes.func.isRequired,
}

export default CourseTypeFilter



// WEBPACK FOOTER //
// ./src/browser/components/filters/CourseTypeFilter.js